import { render } from "./AutomatizacionDeControl.vue?vue&type=template&id=67dd6229&scoped=true"
import script from "./AutomatizacionDeControl.vue?vue&type=script&lang=js"
export * from "./AutomatizacionDeControl.vue?vue&type=script&lang=js"

import "./AutomatizacionDeControl.vue?vue&type=style&index=0&id=67dd6229&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67dd6229"]])

export default __exports__